import {
  GET_PRODUCTS_REQUEST,
  GET_PRODUCTS_LOADED,
  GET_CART_REQUEST,
  GET_CART_SUCCESS,
  GET_CART_FAILURE,
} from "../../constants";
import { createAction, createErrorAction } from "../../utils";
import showError from "../showError/showError";

// Cart
const getCartRequest = createAction(GET_CART_REQUEST);
const getCartSuccess = createAction(GET_CART_SUCCESS);
const getCartFailure = createErrorAction(GET_CART_FAILURE);
const setProductsLoading = createAction(GET_PRODUCTS_REQUEST);
const setProductsLoaded = createAction(GET_PRODUCTS_LOADED);

export const removeAddonProductWithoutDomain = (addonProductId) => {
  return async (dispatch, getState, { api }) => {
    // Load requests
    dispatch(getCartRequest());
    dispatch(setProductsLoading());

    let responseData = {
      getCart: false,
    };

    await api.removeAddonProductWithoutDomain(addonProductId).then(
      (data) => {},
      (err) => {
        dispatch(showError("default"));
        console.error(
          "Specified addon product is not an existing addon product.",
          err,
        );
      },
    );

    // Get the updated cart
    await api.getCart().then(
      (data) => {
        responseData.getCart = data;
      },
      (err) => {
        console.error("Get cart failed", err);
        dispatch(showError("cartUpdateFailed"));
        dispatch(getCartFailure(err));
      },
    );

    if (responseData.getCart) {
      dispatch(getCartSuccess(responseData.getCart));
    }
    dispatch(setProductsLoaded());
  };
};
